import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, switchMap, mergeMap } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/forkJoin';
import { LogService } from './log.service';

export interface TransactionRecord {
  _id?: string;
  IBZ_BANK: string; IBZ_ACC: string;
  IBZ_TRN_D: number; IBZ_TRN_M: number; IBZ_TRN_Y: number; IBZ_TRN_T: string;
  FIN_TRN_D: number; FIN_TRN_M: number; FIN_TRN_Y: number;
  IBZ_DESC: string; IBZ_CHQ: string; IBZ_BRN: string;
  IBZ_OUT: number; IBZ_IN: number; IBZ_BLC: number;
  IBZ_TLR: string; IBZ_SRC: string; IBZ_PYE: string;
  IBZ_RF1: string; IBZ_RF2: string; IBZ_RF3: string; IBZ_RF4: string;
  IBZ_RECP_NO: string; genRecp: boolean; IBZ_ASG: boolean; isDisabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BankImportService {

  constructor(private http: HttpClient, private logService: LogService) { }

  public parseFile(decodedFileContent: string, formatId: string): TransactionRecord[] {
    try {
      switch (formatId) {
        case 'ttb-csv-v1': return this._parseTtbCsv(decodedFileContent);
        case 'kbank-csv-v1': return this._parseKbankCsv(decodedFileContent);
        default: console.error('Unknown format ID:', formatId); return [];
      }
    } catch (error) {
      console.error("CRITICAL ERROR during parsing in Service!", error);
      return [];
    }
  }

  public generateReceiptNumbers(records: TransactionRecord[]): Observable<any> {
    if (!records || records.length === 0) {
      return Observable.of({ records: [], counter: null, counterNoRecp: null, chequeMap: {} });
    }
    const year = records[0].IBZ_TRN_Y;
    const month = records[0].IBZ_TRN_M;
    return this._getOrCreateCounter(year, month).pipe(
      mergeMap(counter => { // ✅ เปลี่ยนจาก switchMap → mergeMap
        counter = { ...counter }; // ป้องกัน reference share
        const noRecpCounter$ = this.http.get('/ibzrecpno/99/99');
        const cheque$ = this.http.get('/cheque');

        return forkJoin([noRecpCounter$, cheque$]).pipe(
          map(([noRecpCounterData, chequeData]) => {
            const counterNoRecp = (Array.isArray(noRecpCounterData) && noRecpCounterData.length > 0)
              ? noRecpCounterData[0]
              : { IBZ_RECP_C: 0, _id: null };

            const chequeMap = {};
            if (Array.isArray(chequeData)) {
              chequeData.forEach(chq => {
                if (!chq.MATCH_CHQ) chequeMap[chq.RECP_NO] = chq;
              });
            }

            console.log("🚀 counter before assign loop:", counter.IBZ_RECP_C);
            records.forEach(rec => {
              this._assignSingleReceipt(rec, counter, counterNoRecp, chequeMap);
            });

            console.log("✅ counter after assign loop:", counter.IBZ_RECP_C);
            return { records, counter, counterNoRecp, chequeMap };
          })
        );
      })
    );
  }

  public saveRecordsAndCounters(payload: { records: TransactionRecord[], counter: any, counterNoRecp: any, chequeMap: any, profile: any }): Observable<any> {
    const { records, counter, counterNoRecp, chequeMap, profile } = payload;
    const screenId = this.logService.SCREEN.SCRN_TTB_IMP.ID;
    
    // 1. บันทึกทุกรายการ transaction
    const saveObservables = records.map(record => this.http.post('/ibzunsec', record).pipe(map((res: any) => {
        this._saveNote(res._id, `Import from IBIZ by ${profile.email}`);
        return res;
    })));

    return Observable.forkJoin(saveObservables).pipe(
      // 2. เมื่อบันทึก transaction เสร็จแล้ว ให้ทำการ update counter และ cheque
      switchMap(results => {
        this.logService.log(this.logService.LOG_ACTION.IMPORT, screenId, `IMPORT : '${results.length}' records`, profile.email);
        
        const updateObservables = [];
        // เพิ่ม counter ที่มีการเปลี่ยนแปลง
        if (counter && counter._id) { updateObservables.push(this.http.put(`/ibzrecpno/${counter._id}`, counter)); }
        // เพิ่ม no-receipt counter ที่มีการเปลี่ยนแปลง
        if (counterNoRecp && counterNoRecp._id) { updateObservables.push(this.http.put(`/ibzrecpno/${counterNoRecp._id}`, counterNoRecp)); }
        // เพิ่ม cheque ที่มีการเปลี่ยนแปลงสถานะ
        for (const recpNo in chequeMap) { if (chequeMap[recpNo].MATCH_CHQ) { updateObservables.push(this.http.put(`/cheque/${chequeMap[recpNo]._id}`, chequeMap[recpNo])); } }
        
        if(updateObservables.length > 0) {
            this.logService.log(this.logService.LOG_ACTION.MODIFY, screenId, `Update Counter`, `${profile.email} (${this.logService.AUTO})`);
            return Observable.forkJoin(updateObservables);
        }
        return Observable.of(results);
      })
    );
  }

  // --- Private Helper Functions (Complete Implementation) ---

  // private _getOrCreateCounter(year: number, month: number): Observable<any> {
  //   return this.http.get(`/ibzrecpno/${year}/${month}`).pipe(
  //     switchMap((counterData: any[]) => {
  //       if (counterData && counterData.length > 0) {
  //         return Observable.of(counterData[0]);
  //       }
  //       // ถ้าไม่มี counter, สร้างใหม่แล้ว get อีกครั้ง
  //       const newCounter = { IBZ_RECP_Y: year, IBZ_RECP_M: month, IBZ_RECP_C: 0, CRT_USER: "SYSTEM", UPD_USER: "SYSTEM" };
  //       return this.http.post('/ibzrecpno', newCounter).pipe(
  //         switchMap((created: any) => this.http.get(`/ibzrecpno/${created._id}`)),
  //         map((res: any[]) => (res.length > 0 ? res[0] : newCounter))
  //       );
  //     })
  //   );
  // }

  private _getOrCreateCounter(year: number, month: number): Observable<any> {
    return this.http.get(`/ibzrecpno/${year}/${month}`).pipe(
      map((counterData: any) => {
        const hasData =
          (Array.isArray(counterData) && counterData.length > 0) ||
          (!Array.isArray(counterData) && counterData && Object.keys(counterData).length > 0);

        if (hasData) {
          const counter = Array.isArray(counterData) ? counterData[0] : counterData;
          console.log("✅ return counter from DB", counter);
          return { ...counter }; // clone ป้องกัน overwrite
        } else {
          console.log("⚠️ no counter found, creating new one");
          return null;
        }
      }),
      switchMap(counter => {
        if (counter) return of(counter);
        const newCounter = {
          IBZ_RECP_Y: year,
          IBZ_RECP_M: month,
          IBZ_RECP_C: 0,
          CRT_USER: "SYSTEM",
          UPD_USER: "SYSTEM"
        };
        return this.http.post('/ibzrecpno', newCounter).pipe(
          switchMap(() => this.http.get(`/ibzrecpno/${year}/${month}`)),
          map((res: any) => (Array.isArray(res) ? res[0] : res))
        );
      })
    );
  }
  
  private _saveNote(id: string, message: string): void {
    const note_ins = { IBZ_ID: id, IBZ_NOTE: message, CRT_USER: "SYSTEM", UPD_USER: "SYSTEM" };
    this.http.post('/ibznote', note_ins).subscribe(() => {}, err => console.error(err));
  }

  private _assignSingleReceipt(rec: TransactionRecord, counter: any, counterNoRecp: any, chequeMap: any): void {
    console.log("🚀 inside assign start:", counter.IBZ_RECP_C, rec);
    const sMonth = this._getMonthString(rec.IBZ_TRN_M);
    const nYear = rec.IBZ_TRN_Y - 2000;
    let matchChq = false;

    if (rec.IBZ_ASG) {
      if (rec.genRecp) {
        counter.IBZ_RECP_C++;
        rec.IBZ_RECP_NO = `${sMonth}.${nYear}-${this._getCounterString(counter.IBZ_RECP_C)}`;
      } else if (rec.IBZ_IN > 0) {
        for (const recpNo in chequeMap) {
          if (rec.IBZ_IN == chequeMap[recpNo].CHQ_AMT) {
            rec.IBZ_RECP_NO = recpNo;
            const chqDate = new Date(chequeMap[recpNo].CHQ_DATE);
            rec.IBZ_TRN_D = chqDate.getDate();
            rec.IBZ_TRN_M = chqDate.getMonth() + 1;
            rec.IBZ_TRN_Y = chqDate.getFullYear();
            chequeMap[recpNo].MATCH_CHQ = true;
            matchChq = true;
            break;
          }
        }
        if (!matchChq && counterNoRecp) {
          counterNoRecp.IBZ_RECP_C++;
          rec.IBZ_RECP_NO = `NO R.${counterNoRecp.IBZ_RECP_C}`;
        }
      }
    } else {
      rec.IBZ_RF4 = "N";
    }
  }

  private _parseTtbCsv(content: string): TransactionRecord[] {
    const allLines = content.split(/\r\n|\n/);
    const dataArr: TransactionRecord[] = [];
    for (let i = 1; i < allLines.length; i++) {
      try {
        const line = allLines[i];
        if (!line || line.trim() === '') continue;
        const data = line.split(',');
        if (data.length < 14) continue;
        const tranDatesStr = data[1] && data[1].trim();
        const finDatesStr = data[2] && data[2].trim();
        if (!tranDatesStr || !finDatesStr) continue;
        const tranDates = tranDatesStr.split('/');
        const finDates = finDatesStr.split('/');
        if (tranDates.length !== 3 || finDates.length !== 3) continue;
        const creditAmount = parseFloat(data[6].trim().replace(/,/g, '')) || 0;
        const record: TransactionRecord = {
          IBZ_BANK: "TTB", IBZ_ACC: data[0].trim(),
          IBZ_TRN_D: parseInt(tranDates[0], 10), IBZ_TRN_M: parseInt(tranDates[1], 10), IBZ_TRN_Y: parseInt(tranDates[2], 10),
          IBZ_TRN_T: data[11].trim(),
          FIN_TRN_D: parseInt(finDates[0], 10), FIN_TRN_M: parseInt(finDates[1], 10), FIN_TRN_Y: parseInt(finDates[2], 10),
          IBZ_BRN: data[3].trim(), IBZ_CHQ: data[4].trim(),
          IBZ_OUT: parseFloat(data[5].trim().replace(/,/g, '')) || 0, IBZ_IN: creditAmount,
          IBZ_BLC: parseFloat(data[7].trim().replace(/,/g, '')) || 0,
          IBZ_SRC: data[8].trim(), IBZ_DESC: data[9].trim(), IBZ_PYE: data[10].trim(),
          IBZ_RF1: data[12].trim(), IBZ_RF2: data[13].trim(), IBZ_RF3: data[1].trim(),
          IBZ_TLR: "", IBZ_RECP_NO: "",
          IBZ_RF4: creditAmount === 0 ? "O" : "",
          genRecp: creditAmount > 0, IBZ_ASG: creditAmount > 0, isDisabled: false
        };
        dataArr.push(record);
      } catch (e) { console.error(`Error parsing TTB line ${i + 1}: "${allLines[i]}"`, e); }
    }
    return dataArr.sort((a, b) => (a.IBZ_TRN_T || "").localeCompare(b.IBZ_TRN_T || ""));
  }

  private _parseKbankCsv(fileContent: string): TransactionRecord[] {
    const allLines = fileContent.split(/\r\n|\n/);
    const dataArr: TransactionRecord[] = [];
    const headerRowIndex = allLines.findIndex(line => line.includes('วันที่ทำรายการ'));
    if (headerRowIndex === -1) {
      this.logService.openSnackBar('ไม่พบหัวตารางที่ถูกต้องในไฟล์ KBANK', 'ผิดพลาด');
      return [];
    }
    const dataStartIndex = headerRowIndex + 1;
    let accountNumber = '';
    const accountLine = allLines.find(line => line.includes("เลขที่บัญชี"));
    if (accountLine) { 
      const parts = accountLine.split(','); 
      if (parts.length > 1) { 
        accountNumber = parts[1].trim().replace(/'/g, ''); 
      } 
    }
    for (let i = dataStartIndex; i < allLines.length; i++) {
      try {
        const line = allLines[i].trim();
        if (!line || line.toLowerCase().startsWith('รวม')) { break; }
        const columns = line.split(',');
        if (columns.length < 8) continue;
        const dateParts = this._parseThaiShortDate(columns[0].trim());
        if (!dateParts) continue;
        const creditAmount = parseFloat(columns[5].trim()) || 0;
        const record: TransactionRecord = {
          IBZ_BANK: "KBANK", IBZ_ACC: accountNumber,
          IBZ_TRN_D: dateParts.day, IBZ_TRN_M: dateParts.month, IBZ_TRN_Y: dateParts.year,
          IBZ_TRN_T: columns[1].trim(), IBZ_DESC: columns[2].trim(),
          IBZ_SRC: columns[7].trim(), IBZ_OUT: parseFloat(columns[4].trim()) || 0,
          IBZ_IN: creditAmount, IBZ_BLC: parseFloat(columns[6].trim()) || 0,
          genRecp: creditAmount > 0, IBZ_ASG: creditAmount > 0,
          FIN_TRN_D: dateParts.day, FIN_TRN_M: dateParts.month, FIN_TRN_Y: dateParts.year,
          IBZ_CHQ: "", IBZ_BRN: "", IBZ_TLR: "", IBZ_PYE: "", IBZ_RF1: "", IBZ_RF2: "",
          IBZ_RF3: "", IBZ_RF4: "", IBZ_RECP_NO: "", isDisabled: false
        };
        dataArr.push(record);
      } catch (e) { console.error(`Error parsing KBANK line ${i + 1}: "${allLines[i]}"`, e); }
    }
    return dataArr;
  }
  
  private _parseThaiShortDate(dateStr: string): { day: number, month: number, year: number } | null {
    const thaiMonths = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
    const parts = dateStr.split('-');
    if (parts.length !== 3) return null;
    try {
        const day = parseInt(parts[0], 10);
        const monthIndex = thaiMonths.findIndex(m => parts[1].includes(m));
        const year = parseInt(parts[2], 10) - 543;
        if (isNaN(day) || monthIndex === -1 || isNaN(year)) return null;
        return { day, month: monthIndex + 1, year };
    } catch(e) { return null; }
  }

  private _getMonthString(month: number): string {
    const months = ["", "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    return months[month] || "";
  }
  
  private _getCounterString(counter: number): string {
    if (counter < 10) return `00${counter}`;
    if (counter < 100) return `0${counter}`;
    return counter.toString();
  }
}